import React, { useRef, useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Pagination,
    Box,
    TextField,
    MenuItem,
    Button
} from '@mui/material';
import colors from '../theme/Colors';
import { api } from '../helpers/apiRequest';
import CustomSelect from './CustomSelect';
import { toast } from 'react-toastify';



const PurchaseOrderTable = ({ item, pstyle, fromDate, toDate, setItem, setPstyle, userInfo, refreshTable, setRefreshTable, isAddingNewRow, setIsAddingNewRow, customerSearch, selectedMerchant, accessControl }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [PurchaseOrderData, setPurchaseOrderData] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [newRowData, setNewRowData] = useState({
        customer: '',
        poNumber: '',
        item: '',
        pStyle: '',
        factoryRate: '',
        partyRates: '',
        extraFreight: '',
        planning: '',
        knitting: '',
        dying: '',
        stitching: '',
        ready: '',
        poDate: '',
        exFactoryDate: '',
        poQuantity: '',
        shippedQty1: '',
        lotDate1: '',
        shippedQty2: '',
        lotDate2: '',
        balanceQty: '',
        achivt: '',
        note: '',
    });
    const [customers, setCustomers] = useState([]);
    const [editingRow, setEditingRow] = useState(null);

    const TABLE_HEADERS = [
        { id: 'customer', label: 'Customer', minWidth: 150 },
        { id: 'poNumber', label: 'PO NUMBER', minWidth: 120 },
        { id: 'item', label: 'ITEM', minWidth: 200 },
        { id: 'pStyle', label: 'P Style', minWidth: 200 },
        // { id: 'style', label: 'Style', minWidth: 200 },
        ...(userInfo?.role !== 'customer' ? [{ id: 'factoryRate', label: 'FACTORY RATE', minWidth: 120 }] : []),
        ...(userInfo?.role !== 'merchant' ? [{ id: 'partyRates', label: 'Party RATE', minWidth: 120 }] : []),
        { id: 'extraFreight', label: 'EXTRA FREIGHT', minWidth: 120 },
        { id: 'planning', label: 'PLANNING', minWidth: 100, type: 'date' },
        { id: 'knitting', label: 'KNITTING', minWidth: 100, type: 'date' },
        { id: 'dying', label: 'DYING', minWidth: 100, type: 'date' },
        { id: 'stitching', label: 'STITCHING', minWidth: 100, type: 'date' },
        { id: 'ready', label: 'READY', minWidth: 100 },
        { id: 'poDate', label: 'PO DATE', minWidth: 120, type: 'date' },
        { id: 'exFactoryDate', label: 'EX - FACTORY DATE', minWidth: 150, type: 'date' },
        { id: 'poQuantity', label: 'PO QUANTITY', minWidth: 120 },
        { id: 'shippedQty1', label: 'SHIPPED QTY', minWidth: 120 },
        { id: 'lotDate1', label: 'LOT/DATE', minWidth: 150, type: 'date' },
        { id: 'shippedQty2', label: 'SHIPPED QTY', minWidth: 120 },
        { id: 'lotDate2', label: 'LOT/DATE', minWidth: 150, type: 'date' },
        { id: 'balanceQty', label: 'BALANCE QTY', minWidth: 120 },
        { id: 'achivt', label: 'ACHIVT', minWidth: 200 },
        { id: 'note', label: 'NOTE', minWidth: 200 },
        { id: 'actions', label: 'Actions', minWidth: 150 }
    ];
    const parseLotDate = (lotDateString) => {
        if (!lotDateString) return { lot: '', date: '' };
        const [lot, date] = lotDateString.split(' - ');
        return { lot: lot || '', date: date || '' };
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };
    const getApiEndpoint = () => {
        switch (userInfo?.role) {
            case 'admin':
                return `/orders/getPos`;
            case 'customer':
                return `/orders/poByCustomer/${userInfo?.id}`;
            case 'merchant':
                return `/orders/poByMerchant/${userInfo?.id}`;
            default:
                return null;
        }
    };

    // const fetchPurchaseOrderData = async (rpp, customerSearchRef, selectedMerchantRef) => {
    //     try {
    //         console.log("called for customerSearch:", customerSearch);
    //         const endpoint = getApiEndpoint();
    //         if (!endpoint) return;

    //         const queryParams = new URLSearchParams();
    //         queryParams.append('page', page + 1);
    //         queryParams.append('limit', rpp);

    //         if (userInfo?.role === 'admin' && selectedMerchantRef && selectedMerchantRef !== 'all') {
    //             queryParams.append('merchant', selectedMerchantRef);
    //         }

    //         if (customerSearchRef) {
    //             if (customerSearchRef !== 'all') {
    //                 queryParams.append('customer', customerSearchRef);
    //             }
    //         }
    //         console.log("here are the queryparams:", `${endpoint}?${queryParams.toString()}`);
    //         const response = await api.get(
    //             `${endpoint}?${queryParams.toString()}`
    //         );
    //         console.log("response?.data?.data:", response?.data?.data);
    //         const ordersData = Array.isArray(response.data.data)
    //             ? response.data.data
    //             : Array.isArray(response.data)
    //                 ? response.data
    //                 : [];

    //         setPurchaseOrderData(ordersData);

    //         // Calculate total pages based on the data structure
    //         const totalCount = response.data.total_count || response.data.length;
    //         setTotalPages(Math.ceil(totalCount / rpp));
    //         setRefreshTable(false);
    //     } catch (error) {
    //         console.error('Error fetching purchase orders:', error);
    //     }
    // };
    // useEffect(()=>{
    //     fetchPurchaseOrderData(rppRef.current, customerRef.current, merchantRef.current,itemRef,pStyleRef);
    // },[item,pstyle]);
    const fetchPurchaseOrderData = async (
        rpp,
        customerSearchRef,
        selectedMerchantRef,
        iRef,
        psRef,
        fromDateRef,
        toDateRef
    ) => {
        try {
            console.log("called for customerSearch:", customerSearch);
            const endpoint = getApiEndpoint();
            if (!endpoint) return;

            const queryParams = new URLSearchParams();
            queryParams.append("page", page + 1);
            queryParams.append("limit", rpp);
            if (toDateRef && toDateRef.current) {
                queryParams.append('todate', toDateRef.current);
            }
            if (fromDateRef && fromDateRef.current) {
                queryParams.append('fromdate', fromDateRef.current);
            }
            if (userInfo?.role === "admin" && selectedMerchantRef && selectedMerchantRef !== "all") {
                queryParams.append("merchant", selectedMerchantRef);
            }

            if (customerSearchRef && customerSearchRef !== "all") {
                console.log("customer search ref is :",customerSearchRef);
                queryParams.append("customer", customerSearchRef);
            }

            if (psRef?.current && psRef?.current !== "all") {
                console.log("psRef:",psRef);
                queryParams.append("pStyle", psRef?.current);
            }

            if (iRef?.current && iRef?.current !== "all") {
                queryParams.append("item", iRef?.current);
            }

            console.log("here are the queryparams:", `${endpoint}?${queryParams.toString()}`);
            const response = await api.get(`${endpoint}?${queryParams.toString()}`);

            console.log("response?.data?.data:", response?.data?.data);
            const ordersData = Array.isArray(response.data.data)
                ? response.data
                : Array.isArray(response.data)
                    ? response.data
                    : [];

            setPurchaseOrderData(ordersData);


            // Calculate total pages based on the data structure
            const totalCount = response.data.total_count || response.data.length;
            setTotalPages(Math.ceil(totalCount / rpp));
            setRefreshTable(false);
        } catch (error) {
            console.error("Error fetching purchase orders:", error);
        }
    };

    const fetchCustomers = async (id = null) => {
        try {
            let response;
            if (userInfo?.role === 'admin' && id) {
                response = await api.get(`/users/merchant/customers/${id}`);
            } else {
                response = await api.get(`/users/merchant/customers/${userInfo?.id}`);
            }
            setCustomers(response.data.data || []);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const rppRef = useRef(rowsPerPage);
    const customerRef = useRef(customerSearch);
    const merchantRef = useRef(selectedMerchant);
    useEffect(() => {
        rppRef.current = rowsPerPage;
    }, [rowsPerPage]);
    useEffect(() => {
        customerRef.current = customerSearch;
    }, [customerSearch]);
    useEffect(() => {
        merchantRef.current = selectedMerchant;
    }, [selectedMerchant]);
    const itemRef = useRef(item);
    useEffect(() => {
        console.log("ggonnna set the item ref to:", item.name);

        itemRef.current = item?.target?.value;
    }, [item]);
    const pStyleRef = useRef(pstyle);
    useEffect(() => {
        console.log("ggonnna set the psyyle ref to:", pstyle);
        pStyleRef.current = pstyle?.target?.value;
    }, [pstyle]);
    const toDateRef = useRef(toDate);
    useEffect(() => {
        toDateRef.current = toDate;
    }, [toDate]);
    const fromDateRef = useRef(fromDate);
    useEffect(() => {
        fromDateRef.current = fromDate;
    }, [fromDate]);
    useEffect(() => {
        console.log("customer search:",customerSearch);
        fetchPurchaseOrderData(rppRef.current, customerRef.current, merchantRef.current, itemRef, pStyleRef, fromDateRef, toDateRef);
        fetchCustomers();
    }, [page, rowsPerPage, refreshTable, customerSearch, selectedMerchant, item, pstyle, fromDate, toDate]);
    useEffect(() => {
        const interval = setInterval(() => {
            console.log('called');
            if (!editingRow) {
                fetchPurchaseOrderData(rppRef.current, customerRef.current, merchantRef.current, itemRef, pStyleRef, fromDateRef, toDateRef);
            }
            // fetchCustomers();
        }, 10000); // 10000ms = 10 seconds

        // Cleanup interval on unmount
        return () => clearInterval(interval);
    }, []);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleNewRowChange = (field, value) => {
        if (field === 'lotDate1' || field === 'lotDate2') {
            const currentValue = newRowData[field];
            const { lot } = parseLotDate(currentValue);
            if (value.includes('-')) {
                setNewRowData(prev => ({
                    ...prev,
                    [field]: `${lot} - ${value}`
                }));
            } else {
                const { date } = parseLotDate(currentValue);
                setNewRowData(prev => ({
                    ...prev,
                    [field]: `${value} - ${date}`
                }));
            }
        } else {
            setNewRowData(prev => {
                const updatedData = {
                    ...prev,
                    [field]: value
                };

                // Automatically calculate balanceQty when poQuantity, shippedQty1, or shippedQty2 changes
                if (field === 'poQuantity' || field === 'shippedQty1' || field === 'shippedQty2') {
                    const poQuantity = field === 'poQuantity' ? parseInt(value) || 0 : parseInt(prev.poQuantity) || 0;
                    const shippedQty1 = field === 'shippedQty1' ? parseInt(value) || 0 : parseInt(prev.shippedQty1) || 0;
                    const shippedQty2 = field === 'shippedQty2' ? parseInt(value) || 0 : parseInt(prev.shippedQty2) || 0;

                    const balanceQty = poQuantity - shippedQty1 - shippedQty2;
                    updatedData.balanceQty = balanceQty >= 0 ? balanceQty.toString() : '0';
                }

                return updatedData;
            });
        }
    };

    const handleSave = async () => {
        try {
            const payload = {
                customerId: newRowData.customer,
                poNumber: newRowData.poNumber,
                item: newRowData.item,
                pStyle: newRowData.pStyle,
                style: newRowData.style,
                factoryRate: parseFloat(newRowData.factoryRate),
                partyRates: parseFloat(newRowData?.partyRates),
                extraFreight: parseFloat(newRowData.extraFreight),
                planning: newRowData.planning,
                knitting: newRowData.knitting,
                dying: newRowData.dying,
                stitching: newRowData.stitching,
                poDate: newRowData.poDate,
                exFactoryDate: newRowData.exFactoryDate,
                poQuantity: parseInt(newRowData.poQuantity),
                shippedQuantity: parseInt(newRowData.shippedQty1),
                lot1: parseLotDate(newRowData.lotDate1).lot,
                lotDate1: parseLotDate(newRowData.lotDate1).date,
                shippedQuantity2: parseInt(newRowData.shippedQty2),
                lot2: parseLotDate(newRowData.lotDate2).lot,
                lotDate2: parseLotDate(newRowData.lotDate2).date,
                balanceQuantity: parseInt(newRowData.balanceQty),
                ready: newRowData.ready,
                note: newRowData.note,
            };
            if (!payload?.customerId) {
                toast.warn('Customer is required');
                return;
            }
            if (!payload?.item) {
                toast.warn('Item is required');
                return;
            }
            if (!payload?.pStyle) {
                toast.warn('P-Style is required');
                return;
            }
            // if (!payload?.style) {
            //     toast.warn('Style is required');
            //     return;
            // }
            if (!payload?.poNumber) {
                toast.warn('PoNumber is required');
                return;
            }
            await api.post('/orders/placepurchaseorder', payload);

            // Reset form and refresh table
            setIsAddingNewRow(false);
            setNewRowData({
                customer: '',
                poNumber: '',
                item: '',
                pStyle: '',
                style: '',
                factoryRate: '',
                partyRates: '',
                extraFreight: '',
                planning: '',
                knitting: '',
                dying: '',
                stitching: '',
                poDate: '',
                exFactoryDate: '',
                poQuantity: '',
                shippedQty1: '',
                lotDate1: '',
                shippedQty2: '',
                lotDate2: '',
                balanceQty: '',
                achivt: '',
                ready: '',
                note: '',
            });
            setRefreshTable(true);
        } catch (error) {
            console.error('Error saving purchase order:', error);
            // You might want to add error handling/notification here
        }
    };

    const handleCancel = () => {
        setIsAddingNewRow(false);
        setNewRowData({
            customer: '',
            poNumber: '',
            item: '',
            pStyle: '',
            style: '',
            factoryRate: '',
            partyRates: '',
            extraFreight: '',
            planning: '',
            knitting: '',
            dying: '',
            stitching: '',
            poDate: '',
            exFactoryDate: '',
            poQuantity: '',
            shippedQty1: '',
            lotDate1: '',
            shippedQty2: '',
            lotDate2: '',
            balanceQty: '',
            achivt: '',
            ready: '',
            note: '',
        });
    };

    const formatDateForInput = (date) => {
        if (!date) return '';
        try {
            // Check if date is already in YYYY-MM-DD format
            if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
                return date;
            }
            const d = new Date(date);
            // Check if date is valid
            if (isNaN(d.getTime())) {
                return '';
            }
            return d.toISOString().split('T')[0];
        } catch (error) {
            console.warn('Invalid date:', date);
            return '';
        }
    };

    const handleEdit = (row) => {

        let customerId = '';
        if (row.customer && typeof row.customer === 'object' && row.customer._id) {
            customerId = row.customer._id;
        } else if (row.customerId) {
            customerId = row.customerId;
        }
        fetchCustomers(row?.merchant?._id);
        console.log('Selected customer ID:', customerId);

        setEditingRow(row._id);
        setNewRowData({
            customer: customerId,
            poNumber: row.poNumber,
            item: row.item,
            pStyle: row.pStyle,
            // style: row.style,
            factoryRate: row.factoryRate,
            partyRates: row?.partyRates,
            extraFreight: row.extraFreight,
            planning: row.planning,
            knitting: row.knitting,
            dying: row.dying,
            stitching: row.stitching,
            poDate: formatDateForInput(row.poDate),
            exFactoryDate: formatDateForInput(row.exFactoryDate),
            poQuantity: row.poQuantity,
            shippedQty1: row.shippedQuantity,
            lotDate1: row.lot1 && row.lotDate1
                ? `${row.lot1} - ${formatDateForInput(row.lotDate1)}`
                : '',
            shippedQty2: row.shippedQuantity2,
            lotDate2: row.lot2 && row.lotDate2
                ? `${row.lot2} - ${formatDateForInput(row.lotDate2)}`
                : '',
            balanceQty: row.balanceQuantity,
            achivt: row.achievement,
            ready: row.ready,
            note: row.note,
        });
    };

    const handleUpdate = async (rowId) => {
        try {
            const payload = {
                customer: newRowData.customer,
                poNumber: newRowData.poNumber,
                item: newRowData.item,
                pStyle: newRowData.pStyle,
                // style: newRowData.style,
                factoryRate: parseFloat(newRowData.factoryRate),
                partyRates: parseFloat(newRowData.partyRates),
                extraFreight: parseFloat(newRowData.extraFreight),
                planning: newRowData.planning,
                knitting: newRowData.knitting,
                dying: newRowData.dying,
                stitching: newRowData.stitching,
                poDate: newRowData.poDate,
                exFactoryDate: newRowData.exFactoryDate,
                poQuantity: parseInt(newRowData.poQuantity),
                shippedQuantity: parseInt(newRowData.shippedQty1),
                lot1: parseLotDate(newRowData.lotDate1).lot,
                lotDate1: parseLotDate(newRowData.lotDate1).date,
                shippedQuantity2: parseInt(newRowData.shippedQty2),
                lot2: parseLotDate(newRowData.lotDate2).lot,
                lotDate2: parseLotDate(newRowData.lotDate2).date,
                balanceQuantity: parseInt(newRowData.balanceQty),
                achievement: newRowData.achivt,
                ready: newRowData.ready,
                note: newRowData.note,
            };
            console.log("here iss the payload:", payload);
            const response = await api.put(`/orders/purchase-order/${rowId}`, payload);
            console.log("response:", response);
            setEditingRow(null);
            setRefreshTable(true);
        } catch (error) {
            console.error('Error updating purchase order:', error);
        }
    };

    const handleCancelEdit = () => {
        setEditingRow(null);
        setNewRowData({
            customer: '',
            poNumber: '',
            item: '',
            pStyle: '',
            // style: '',
            factoryRate: '',
            partyRates: '',
            extraFreight: '',
            planning: '',
            knitting: '',
            dying: '',
            stitching: '',
            poDate: '',
            exFactoryDate: '',
            poQuantity: '',
            shippedQty1: '',
            lotDate1: '',
            shippedQty2: '',
            lotDate2: '',
            balanceQty: '',
            achivt: '',
            ready: '',
            note: '',
        });
    };

    return (
        <>


            <Box display="flex" justifyContent="flex-end" mt={2}>
                <Table
                    size="small"
                    sx={{
                        maxWidth: 400,
                        margin: 1,
                        border: "1px solid #ccc",
                        borderCollapse: "collapse",
                        "& td": { border: "1px solid #ccc", padding: "6px 12px", textAlign: "center" },
                        "& th": {
                            border: "1px solid #ccc",
                            backgroundColor: colors.primary,
                            color: "black",
                            fontWeight: "bold",
                            textAlign: "center",
                            padding: "6px 12px",
                        },
                    }}
                >
                    <TableHead>
                        <TableRow>
                            <TableCell>T QTY</TableCell>
                            <TableCell>T Shipped</TableCell>
                            <TableCell>T Balance</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{PurchaseOrderData?.totalQuantity || 0}</TableCell>
                            <TableCell>{PurchaseOrderData?.totalShippedQuantity || 0}</TableCell>
                            <TableCell>{PurchaseOrderData?.totalBalance || 0}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>

            <TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {TABLE_HEADERS.map((header) => (
                                <TableCell
                                    key={header.id}
                                    sx={{
                                        border: '1px solid black',
                                        padding: '8px',
                                        backgroundColor: colors.primary,
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        minWidth: header.minWidth,
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {header.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isAddingNewRow && (
                            <TableRow>
                                {TABLE_HEADERS.map((header) => (
                                    <TableCell
                                        key={header.id}
                                        sx={{
                                            border: '1px solid black',
                                            textAlign: 'center',
                                            padding: '8px',
                                            minWidth: header.minWidth
                                        }}
                                    >
                                        {header.id === 'actions' ? (
                                            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    onClick={handleSave}
                                                >
                                                    Save
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    size="small"
                                                    onClick={handleCancel}
                                                >
                                                    Cancel
                                                </Button>
                                            </Box>
                                        ) : header.id === 'customer' ? (
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                value={newRowData[header.id]}
                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                            >
                                                {customers.map((customer) => (
                                                    <MenuItem key={customer.customer._id} value={customer.customer._id}>
                                                        {customer.customer.name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        ) : header.id === 'item' ? (
                                            <TextField
                                                size="small"
                                                fullWidth
                                                value={newRowData[header.id]}
                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                            />
                                        ) : header.id === 'pStyle' ? (
                                            <TextField
                                                size="small"
                                                fullWidth
                                                value={newRowData[header.id]}
                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                            />
                                        ) : header.id === 'lotDate1' || header.id === 'lotDate2' ? (
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <TextField
                                                    size="small"
                                                    placeholder="Lot"
                                                    value={parseLotDate(newRowData[header.id]).lot}
                                                    onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                    sx={{ width: '40%' }}
                                                />
                                                <TextField
                                                    type="date"
                                                    size="small"
                                                    value={parseLotDate(newRowData[header.id]).date}
                                                    onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    sx={{ width: '60%' }}
                                                />
                                            </Box>
                                        ) : header.type === 'date' ? (
                                            <TextField
                                                type="date"
                                                size="small"
                                                fullWidth
                                                value={newRowData[header.id]}
                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        ) : header.id === 'ready' ? (
                                            <TextField
                                                size="small"
                                                fullWidth
                                                value={newRowData[header.id]}
                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                            />
                                        ) : header.id === 'note' ? (
                                            <TextField
                                                size="small"
                                                fullWidth
                                                value={newRowData[header.id]}
                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                            />
                                        ) : header.id === 'achivt' ? (
                                            <TextField
                                                select
                                                size="small"
                                                fullWidth
                                                value={newRowData[header.id]}
                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                            >
                                                <MenuItem value="">Select Achievement</MenuItem>
                                            </TextField>
                                        ) : header.id === 'partyRates' && userInfo?.role !== 'merchant' ? (
                                            <TextField
                                                size="small"
                                                fullWidth
                                                value={newRowData[header.id]}
                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                            />
                                        ) : (
                                            <TextField
                                                size="small"
                                                fullWidth
                                                value={newRowData[header.id]}
                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                            />
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        )}
                        {Array.isArray(PurchaseOrderData?.data) && PurchaseOrderData?.data?.map((row) => (
                            <TableRow key={row._id}>
                                {TABLE_HEADERS.map((header) => (
                                    <TableCell
                                        key={header.id}
                                        sx={{
                                            border: '1px solid black',
                                            textAlign: 'center',
                                            padding: '8px',
                                            minWidth: header.minWidth,
                                            backgroundColor: header.id === 'achivt' ?
                                                (row.achievement === 'ACHEIVED' ? colors.primary :
                                                    row.achievement === 'NOT-ACHIEVED' ? 'yellow' : 'transparent')
                                                : 'transparent'
                                        }}
                                    >
                                        {editingRow === row._id ? (
                                            header.id === 'actions' ? (
                                                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleUpdate(row._id)}
                                                    >
                                                        Save
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="error"
                                                        size="small"
                                                        onClick={handleCancelEdit}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Box>
                                            ) : header.id === 'customer' ? (
                                                <TextField
                                                    select
                                                    fullWidth
                                                    size="small"
                                                    value={newRowData[header.id]}
                                                    onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                >
                                                    {customers.map((customer) => (
                                                        <MenuItem
                                                            key={customer.customer._id}
                                                            value={customer.customer._id}
                                                        >
                                                            {customer.customer.name}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            ) : header.id === 'item' ? (
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    value={newRowData[header.id]}
                                                    onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                />
                                            ) : header.id === 'pStyle' ? (
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    value={newRowData[header.id]}
                                                    onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                />
                                            ) : header.id === 'style' ? (
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    value={newRowData[header.id]}
                                                    onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                />
                                            )
                                                : header.id === 'poNumber' ? (
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        value={newRowData[header.id]}
                                                        onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                    />
                                                )
                                                    : header.id === 'factoryRate' ? (
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            value={newRowData[header.id]}
                                                            onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                        />
                                                    ) : header.id === 'extraFreight' ? (
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            value={newRowData[header.id]}
                                                            onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                        />
                                                    )
                                                        : header.id === 'ready' ? (
                                                            <TextField
                                                                size="small"
                                                                fullWidth
                                                                value={newRowData[header.id]}
                                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                            />
                                                        )
                                                            : header.id === 'shippedQty1' ? (
                                                                <TextField
                                                                    size="small"
                                                                    fullWidth
                                                                    value={newRowData[header.id]}
                                                                    onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                />
                                                            ) : header.id === 'shippedQty2' ? (
                                                                <TextField
                                                                    size="small"
                                                                    fullWidth
                                                                    value={newRowData[header.id]}
                                                                    onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                />
                                                            ) : header.id === 'poQuantity' ? (
                                                                <TextField
                                                                    size="small"
                                                                    fullWidth
                                                                    value={newRowData[header.id]}
                                                                    onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                />
                                                            )
                                                                : header.id === 'lotDate1' || header.id === 'lotDate2' ? (
                                                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                                                        <TextField
                                                                            size="small"
                                                                            placeholder="Lot"
                                                                            value={parseLotDate(newRowData[header.id]).lot}
                                                                            onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                            sx={{ width: '40%' }}
                                                                        />
                                                                        <TextField
                                                                            type="date"
                                                                            size="small"
                                                                            value={parseLotDate(newRowData[header.id]).date}
                                                                            onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            sx={{ width: '60%' }}
                                                                        />
                                                                    </Box>
                                                                ) : header.type === 'date' ? (
                                                                    <TextField
                                                                        type="date"
                                                                        size="small"
                                                                        fullWidth
                                                                        value={formatDateForInput(newRowData[header.id])}
                                                                        onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                        InputLabelProps={{
                                                                            shrink: true,
                                                                        }}
                                                                    />
                                                                ) : header.id === 'ready' ? (
                                                                    row.ready
                                                                ) : header.id === 'note' ? (
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        value={newRowData[header.id]}
                                                                        onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                    />
                                                                ) : header.id === 'achivt' ? (
                                                                    <TextField
                                                                        select
                                                                        size="small"
                                                                        fullWidth
                                                                        value={newRowData[header.id]}
                                                                        onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                    >
                                                                        <MenuItem value="">Select Achievement</MenuItem>
                                                                        <MenuItem value="NOT-ACHIEVED">NOT-ACHIEVED</MenuItem>
                                                                        <MenuItem value="ACHEIVED">ACHEIVED</MenuItem>
                                                                    </TextField>
                                                                ) : header.id === 'partyRates' && userInfo?.role !== 'merchant' ? (
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        value={newRowData[header.id]}
                                                                        onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                    />
                                                                ) : header.id === 'partyRates' && userInfo?.role === 'merchant' ? null : (
                                                                    (() => {
                                                                        if (header.type === 'date') {
                                                                            return formatDateForInput(row[header.id]);
                                                                        }

                                                                        switch (header.id) {
                                                                            case 'customer':
                                                                                return row.customer?.name || '';
                                                                            case 'item':
                                                                                return typeof row.item === 'object' ? row.item?.name || '' : row.item || '';
                                                                            case 'pStyle':
                                                                                return typeof row.pStyle === 'object' ? row.pStyle?.name || '' : row.pStyle || '';
                                                                            case 'shippedQty1':
                                                                                return row.shippedQuantity || '';
                                                                            case 'shippedQty2':
                                                                                return row.shippedQuantity2 || '';
                                                                            case 'balanceQty':
                                                                                return row.balanceQuantity || '';
                                                                            case 'lotDate1':
                                                                                return row.lot1 && row.lotDate1
                                                                                    ? `${row.lot1} - ${formatDateForInput(row.lotDate1)}`
                                                                                    : '';
                                                                            case 'lotDate2':
                                                                                return row.lot2 && row.lotDate2
                                                                                    ? `${row.lot2} - ${formatDateForInput(row.lotDate2)}`
                                                                                    : '';
                                                                            case 'partyRates':
                                                                                return row.partyRates || '';
                                                                            default:
                                                                                return row[header.id] || '';
                                                                        }
                                                                    })()
                                                                )
                                        ) : (
                                            header.id === 'actions' ? (
                                                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                                                    {(userInfo?.role === 'admin' || accessControl["edit-purchase-order"] === true) && (
                                                        <Button
                                                            sx={{
                                                                backgroundColor: colors.primary,
                                                                color: 'white',
                                                                borderWidth: 2,
                                                                marginLeft: 1,
                                                                borderColor: colors.primary,
                                                            }}
                                                            onClick={() => handleEdit(row)}
                                                        >
                                                            Edit
                                                        </Button>
                                                    )}
                                                </Box>
                                            ) : (
                                                header.id === 'lotDate1' || header.id === 'lotDate2' ? (
                                                    editingRow === row._id ? (
                                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                                            <TextField
                                                                size="small"
                                                                placeholder="Lot"
                                                                value={parseLotDate(newRowData[header.id]).lot}
                                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                sx={{ width: '40%' }}
                                                            />
                                                            <TextField
                                                                type="date"
                                                                size="small"
                                                                value={parseLotDate(newRowData[header.id]).date}
                                                                onChange={(e) => handleNewRowChange(header.id, e.target.value)}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                sx={{ width: '60%' }}
                                                            />
                                                        </Box>
                                                    ) : (
                                                        // row.lot1 && row.lotDate1
                                                        //     ? `${row.lot1} - ${formatDateForInput(row.lotDate1)}`
                                                        //     : ''
                                                        header.id === 'lotDate1'
                                                            ? (row.lot1 && row.lotDate1 ? `${row.lot1} - ${formatDateForInput(row.lotDate1)}` : '')
                                                            : (row.lot2 && row.lotDate2 ? `${row.lot2} - ${formatDateForInput(row.lotDate2)}` : '')
                                                    )
                                                ) : (
                                                    header.id === 'achivt' ? (
                                                        row.achievement || ''
                                                    ) : (
                                                        header.id === 'partyRates' && userInfo?.role === 'merchant' ? null : (
                                                            (() => {
                                                                if (header.type === 'date') {
                                                                    return formatDateForInput(row[header.id]);
                                                                }

                                                                switch (header.id) {
                                                                    case 'customer':
                                                                        return row.customer?.name || '';
                                                                    case 'item':
                                                                        return typeof row.item === 'object' ? row.item?.name || '' : row.item || '';
                                                                    case 'pStyle':
                                                                        return typeof row.pStyle === 'object' ? row.pStyle?.name || '' : row.pStyle || '';
                                                                    case 'shippedQty1':
                                                                        return row.shippedQuantity || 0;
                                                                    case 'shippedQty2':
                                                                        return row.shippedQuantity2 || 0;
                                                                    case 'balanceQty':
                                                                        return row.balanceQuantity || 0;
                                                                    case 'lotDate1':
                                                                        return row.lot1 && row.lotDate1
                                                                            ? `${row.lot1} - ${formatDateForInput(row.lotDate1)}`
                                                                            : '';
                                                                    case 'lotDate2':
                                                                        return row.lot2 && row.lotDate2
                                                                            ? `${row.lot2} - ${formatDateForInput(row.lotDate2)}`
                                                                            : '';
                                                                    case 'partyRates':
                                                                        return row.partyRates || 0;
                                                                    default:
                                                                        return row[header?.id];
                                                                }
                                                            })()
                                                        )
                                                    )
                                                )
                                            )
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2, alignItems: 'center', gap: 2 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        showFirstButton
                        showLastButton
                    />
                    <CustomSelect
                        label="Rows per page"
                        value={rowsPerPage}
                        onChange={handleChangeRowsPerPage}
                        options={[
                            { id: 100, name: '100' },
                            { id: 200, name: '200' },
                            { id: 300, name: '300' },
                            { id: 400, name: '400' },
                            { id: 500, name: '500' },
                            // { id: , name: '25' },
                            // { id: 50, name: '50' },
                        ]}
                        sx={{ minWidth: 120 }}
                    />
                </Box>

            </TableContainer>
        </>
    );
};

export default PurchaseOrderTable;
